import { useState, useEffect } from "react";
import { useQuery } from 'hooks/useQuery';
import { postDoctors, queryYellowPagesDoctorDetail, postDoctorDetail } from "api/doctor-list";
import { useLocation, useParams } from "react-router-dom";
import { getNethpHref } from '@jdhfe/seouifuncs/dist/tools/getNethpHref';
import { Helmet } from "react-helmet";

import logo from "../../asset/img/login/logo.png";
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";
import Triple from "../../asset/img/login/Triple.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Prescribible1 from "../../asset/img/login/Prescribible1.png";
import Group1 from "../../asset/img/login/Group1.png"; // 对勾
import Group2 from "../../asset/img/login/Group2.png"; // 资
import Group3 from "../../asset/img/login/Group3.png"; // 证
import Group4 from "../../asset/img/login/Group4.png"; // 人脸

import backText1 from "../../asset/img/login/backText1.png";
import backText2 from "../../asset/img/login/backText2.png";
import QRCode from "qrcode.react";
import { Popover } from "antd";
import styles from "./index.less";
import { seoFooter } from "utils/seoFooter.js";
import { ErrorComp } from "components/error";
import { handleDoctorData, targetLink } from 'utils/index';
import { getQrCodeUrl } from "utils/doctor";
import { doctorNav } from "utils/hospital";
import { getNavigationBarDtoList } from "api/tab-bar";
import HospitalNav from "pages/hospital/components/Nav";

// 医生主页
const Doctor = () => {
  const params = useParams<Record<any, any>>();
  const query = useQuery<any>();
  const [pageId, setPageId] = useState<any>(params.id);
  const [departData, setDepartData] = useState<any>();
  const [loading, setLoading] = useState(true);

  const [navList, setNavList] = useState<any[]>();
  const getNavigationBarDtoFunc = (baseNav?: any[]) => {
    const baseNavList = baseNav;
    // 后端控制tab的展示和链接
    getNavigationBarDtoList({ currentUrl: window.location.href }).then(
      (res: any) => {
        const realList = res?.map((item: any) => {
          const url = item.url;
          let cItem;
          try {
            const Url = new URL(url);
            const path = Url.pathname;
            cItem = baseNavList?.find((iitem) => iitem.url === path);
          } catch (e) {
            console.log(e);
          }
          return {
            ...cItem,
            ...item,
          };
        });
        setNavList(realList?.length ? realList : undefined);
        // setNavList(realList?.length ? realList : baseNavList);
      }
    ).catch(e=>{
      console.log(e)
      // setNavList(baseNavList);
    })
  };
  useEffect(()=>{
    if(pageId){
      const baseNav = doctorNav(`${pageId}`);
      // @ts-ignore
      // setNavList(baseNav);
      getNavigationBarDtoFunc(baseNav);
    }
  },[pageId]);

  const routerPath = useLocation();
  useEffect(() => {
    if (params.id) {
      setPageId(params.id);
      getinitFun(params.id);
    }
  }, []);

  // 黄页医生详情 黄页 排班
  const pyqueryYellowPagesDoctorDetail = () => {
    queryYellowPagesDoctorDetail({
      yellowpagesDocId: params.id
    }).then((res: any) => {
      setDepartData({
        ...res,
        doctorSource: 1,
        docGoodAt: res.docGoodat || '',
        titleName: res.teacherTitle,
        docId: res.yellowpagesDocId,
        doctorHeadImg: res.docHeadPic
      });
    }).finally(() => setLoading(false));
  }
  
  const getinitFun = (id: any) => {
    if (id) {

      Promise.all([
        queryYellowPagesDoctorDetail({
          yellowpagesDocId: params.id
        }),
        postDoctorDetail({
          doctorId: id,
          onLineChannelName: "nethp",
          queryServiceAndTag: true,
          queryYellowDoctor: true,
        })
      ]).then((result:any) => {
        if(result?.[0]?.yellowpagesDocId){
          const res = result?.[0];
          setDepartData({
            ...res,
            doctorSource: 1,
            docGoodAt: res.docGoodat || '',
            titleName: res.teacherTitle,
            docId: res.yellowpagesDocId,
            doctorHeadImg: res.docHeadPic
          });
        }else if(result?.[1].doctorId){
          const resData:any = handleDoctorData(result?.[1]);
          setDepartData(resData);
        }
      }).catch(() => setLoading(false)).finally(() => setLoading(false));

      // pyqueryYellowPagesDoctorDetail();
      // postDoctorDetail({
      //   doctorId: id,
      //   onLineChannelName: "nethp",
      //   queryServiceAndTag: true,
      //   queryYellowDoctor: true,
      // }).then((res: any) => {
      //   if(res.doctorId){
      //     const resData:any = handleDoctorData(res);
      //     setDepartData(resData);
      //   }
      // }).finally(() => setLoading(false));

      seoFooter();
    }
  };
  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      window.open("/");
    }
  };

  const qrCodeUrl = getQrCodeUrl(pageId);
  const content = (
    <div className={styles.overbookingCodebotton}>
      <QRCode value={qrCodeUrl} size={80} />
      <div>
        <h3>扫码关注医生</h3>
        <h6>关注{departData?.docName}医生，方便随时提问</h6>
      </div>
    </div>
  );

  const onClickhref = async (url: any) => {
    targetLink(url);
  };
  document.title =
    "【" +
    departData?.docName +
    "】" +
    "详细介绍_出诊时间_评价怎么样_" +
    departData?.hospitalName +
    departData?.departName +
    "_京东健康互联网医院";
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute(
      "content",
      departData?.docIntro && departData?.docIntro.substring(0, 100)
    );
  document
    .querySelector('meta[name="keywords"]')
    ?.setAttribute(
      "content",
      departData?.docName +
        "," +
        departData?.docName +
        "详细介绍," +
        departData?.docName +
        "评价怎么样"
    );
  let doctorTagDTOMap =
    departData?.doctorTagDTOMap &&
    Object.keys(departData?.doctorTagDTOMap).length > 0 &&
    departData?.doctorTagDTOMap["1"]
      ? departData?.doctorTagDTOMap["1"].filter((val: any) => {
          return val.dictionaryType == 1 && val.dictionaryId == 10073;
        })
      : "";
  return (
    <div className={styles.jianjie}>
      {
        !loading && !departData && <ErrorComp />
      }
      {/* // top 医生信息*/}
      {
        !loading && departData &&
        <div className={styles.qalistBack}>
          {/* 当前位置： */}
          <div className={styles.describe}>
            <div>
              <p>京东健康</p>
              <span>{">"}</span>
              {/* 京东健康>{医院名称}>{医生姓名}>{医生姓名}医生的详细信息 */}
              {departData?.hospitalName && departData?.docName ? (
                <>
                  <p>{departData?.hospitalName}</p>
                  <span>{">"}</span>
                  <a
                  data-a-href = {
                    "/doctor/" + pageId
                  }
                  onClick={() => {
                    onClickhref("/doctor/" + pageId);
                  }}
                  >{departData?.docName}</a>
                  <span>{">"}</span>
                  <p data-tag-h1>{departData?.docName + "医生的详细信息"}</p>
                </>
              ) : null}
            </div>
          </div>
          {/* 医生信息 */}
          {departData && (
            <div className={styles.qalistBackBox}>
              <div className={styles.qalistBackList}>
                <div className={styles.doctorImg}>
                  <img
                    src={
                      "https://image.healthjd.com/nethpim/" +
                      departData?.doctorHeadImg
                    }
                    alt={departData?.docName}
                  />
                </div>
                <div className={styles.doctorBox}>
                  <div className={styles.doctorBoxTop}>
                    <a
                    data-a-href = {
                      "/doctor/" + pageId
                    }
                    onClick={() => {
                      onClickhref("/doctor/" + pageId);
                    }}
                    >{departData?.docName}</a>
                    <span>{departData?.titleName}</span>
                    {departData?.selfSupport && (
                      <img
                        className={styles.selfSupport}
                        src={selfSupport}
                        alt=""
                      />
                    )}
                    {departData?.operationalOpenRxStatus === 1 && (
                      <img
                        className={styles.operationalOpenRxStatus}
                        src={Prescribible1}
                        alt=""
                      />
                    )}
                    {departData?.hospitalGrade === 3 && (
                      <img className={styles.hospitalGrade} src={Triple} alt="" />
                    )}
                  </div>
                  <div className={styles.doctorBoxTop1}>
                    <span 
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickOpen("/hospital/" + departData?.hospitalId);
                        }}
                        data-a-href={"/hospital/" + departData?.hospitalId}>{departData?.hospitalName}</span>
                      {' '}
                      <span onClick={(e) => {
                        e.stopPropagation();
                        onClickOpen(`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`)
                      }}
                      data-a-href={`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`}
                      >{departData?.secondDepartName}</span>
                  </div>
                  <div className={styles.doctorBoxTop2}>
                    执业证：{departData?.practiceCode || "暂无资料"}
                  </div>
                </div>
              </div>
              {departData?.doctorSource == 0 &&
                (departData?.qualificationsCode ||
                  departData?.practiceCode ||
                  doctorTagDTOMap?.length > 0) && (
                  <div className={styles.qalistBackRight}>
                    <div className={styles.qalistBackRightText}>实名认证</div>
                    {departData?.qualificationsCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group2} alt="" />
                          <div>
                            <span>医师资格证</span>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {departData?.practiceCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group3} alt="" />
                          <div>
                            <span>医师执业照</span>
                            <p>执业证书编号:{departData?.practiceCode}</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {doctorTagDTOMap?.length > 0 && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group4} alt="" />
                          <div>
                            <span>人脸识别认证</span>
                            <p>所有服务均由医生本人提供</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          )}
        </div>
      }
      {/* 导航 */}
      { !loading && departData &&
        <div className={styles.nav}>
          <HospitalNav pageId={pageId} navList={navList} />
        </div>
      }
      {/* 内容 */}
      { !loading && departData &&
        <div className={styles.content}>
          {/* 左 */}
          <div className={styles.left}>
            {/* 医生介绍 */}
            <div className={styles.jianjieList}>
              <div className={styles.jianjieList1}>
                <div className={styles.jianjieListTop}>
                  <div className={styles.jianjieListTopText}>
                    <img src={backText1} alt="专业擅长" />
                  </div>
                </div>
                <div className={styles.jianjieListText}>
                  {(departData?.docGoodAt || departData?.docGoodat) || "暂无擅长"}
                </div>
              </div>
            </div>
            <div className={styles.jianjieListA}>
              <div className={styles.jianjieList2}>
                <div className={styles.jianjieListTop}>
                  <div className={styles.jianjieListTopText}>
                    <img src={backText2} alt="个人简介" />
                  </div>
                </div>
                <div className={styles.jianjieListText}>
                  {departData?.docIntro || "暂无介绍"}
                </div>
              </div>
            </div>
          </div>
          {/* 右 */}
          <div className={styles.right}>
            <div className={styles.rightFloat}>
              {departData && (
                <div className={styles.rightdoctor}>
                  <h2>医生成就</h2>
                  <div className={styles.rightdoctorCont}>
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.patientEvaluationRate?.split('%')?.[0] || "暂无"}
                        <i>{departData?.patientEvaluationRate ? '%' : ""}</i>
                      </span>
                      <p>好评率</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>{departData?.receivePatientNum || "暂无"}</span>
                      <p>接诊人数</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.averageResponseTimeDTO?.averageResponseTime || "暂无"}
                        <i>
                          {departData?.averageResponseTimeDTO?.timeUnit || ""}
                        </i>
                      </span>
                      <p>平均响应</p>
                    </div>
                  </div>
                </div>
              )}
              {departData?.docName && (
                <div className={styles.overbookingCode}>
                  <QRCode
                    value={qrCodeUrl}
                    size={80}
                  />
                  <div>
                    <h3>扫码关注医生</h3>
                    <h6>关注{departData?.docName}医生，方便随时提问</h6>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      }
      {/* // 底部线 */}
      <div className={styles.footerLine}>
        <p></p>
      </div>
      <div className={styles.footerData} id="m_common_bottom" />
      {/* 底部 */}
      <div className={styles.bottom}>
        <div className={styles.bottomDoctorInfo}>
          {departData && (
            <>
              <img
                src={
                  "https://image.healthjd.com/nethpim/" +
                  departData?.doctorHeadImg
                }
                alt={departData?.docName}
              />
              <div className={styles.doctorInfoImgRight}>
                <div className={styles.doctorInfoImgTop}>
                  <div className={styles.doctorInfoImgTopName}>
                    {departData?.docName}
                  </div>
                  <span>{departData?.titleName}</span>
                  {/* <span>{departData?.departName}</span> */}
                  <p>已认证</p>
                </div>
                <div className={styles.doctorInfoImgBotton}>
                  {departData?.hospitalGrade === 3 && (
                    <img src={TripleHospital} alt="" />
                  )}
                  <p>
                    {departData?.hospitalName} {departData?.secondDepartName}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.bottomBtn}>
          <Popover content={content}>
            <button className={styles.bottomBtn1}>立即咨询</button>
          </Popover>
          <Popover content={content}>
            <button className={styles.bottomBtn2}>
              扫码关注医生，方便随时咨询
            </button>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Doctor;
